var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOctagon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 4.66675C8.36852 4.66675 8.66699 4.96522 8.66699 5.33341V8.00008C8.66699 8.36827 8.36852 8.66675 8.00033 8.66675C7.63213 8.66675 7.33366 8.36827 7.33366 8.00008V5.33341C7.33366 4.96522 7.63213 4.66675 8.00033 4.66675Z",
    fill: "#CD1818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 10.0001C7.63213 10.0001 7.33366 10.2986 7.33366 10.6667C7.33366 11.0349 7.63213 11.3334 8.00033 11.3334H8.00699C8.37518 11.3334 8.67366 11.0349 8.67366 10.6667C8.67366 10.2986 8.37518 10.0001 8.00699 10.0001H8.00033Z",
    fill: "#CD1818"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76892 0.86201C4.89395 0.736986 5.06351 0.666748 5.24033 0.666748H10.7603C10.9371 0.666748 11.1067 0.736986 11.2317 0.86201L15.1384 4.76868C15.2634 4.8937 15.3337 5.06327 15.3337 5.24008V10.7601C15.3337 10.9369 15.2634 11.1065 15.1384 11.2315L11.2317 15.1382C11.1067 15.2632 10.9371 15.3334 10.7603 15.3334H5.24033C5.06351 15.3334 4.89395 15.2632 4.76892 15.1382L0.862254 11.2315C0.73723 11.1065 0.666992 10.9369 0.666992 10.7601V5.24008C0.666992 5.06327 0.73723 4.8937 0.862254 4.76868L4.76892 0.86201ZM5.51647 2.00008L2.00033 5.51622V10.4839L5.51647 14.0001H10.4842L14.0003 10.4839V5.51622L10.4842 2.00008H5.51647Z",
    fill: "#CD1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOctagon);
export default __webpack_public_path__ + "static/media/info-octagon.29f40a1c6c49f59d5d8ca305120d7011.svg";
export { ForwardRef as ReactComponent };